import classNames from 'classnames'

import { InfoButton } from 'components/buttons'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { useTracking } from 'lib/analytics'
import { FinalCTASection as FinalCTASectionType } from '../../LandingPage.types'
import css from './FinalCTASection.styles.scss'

interface FinalCTASectionProps {
  section: FinalCTASectionType
}

const FinalCTASection = ({ section }: FinalCTASectionProps) => {
  const [currentUser] = useCurrentUser()
  const tracker = useTracking()
  const {
    heading,
    subHeading,
    callToAction,
    background,
    backgroundColor,
    textColor = 'white',
  } = section

  const colorClassAppend = `__color-${textColor}`
  const backgroundGradientString = background
    ?.toLowerCase()
    .replaceAll(' ', '-')

  return (
    <div
      className={classNames(css.FinalCTASection__container, {
        [css[
          `FinalCTASection__container__backgroundColor--${backgroundColor}`
        ]]: !!backgroundColor,
      })}
    >
      <div
        className={classNames(css.FinalCTASection__curve, {
          [css[
            `FinalCTASection__curve__background--${backgroundGradientString}`
          ]]: !!background,
        })}
      >
        {heading && (
          <h2
            className={classNames(
              css.FinalCTASection__headerText,
              css[`FinalCTASection__headerText${colorClassAppend}`]
            )}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
        )}
        {subHeading && (
          <h3
            className={classNames(
              css.FinalCTASection__subHeaderText,
              css[`FinalCTASection__subHeaderText${colorClassAppend}`]
            )}
            dangerouslySetInnerHTML={{ __html: subHeading }}
          />
        )}
        {callToAction && (
          <InfoButton
            pill
            className={css.FinalCTASection__callToAction}
            href={callToAction.url}
            onClick={() => {
              if (typeof callToAction.onClick === 'function') {
                callToAction.onClick(currentUser, tracker)
              }
            }}
          >
            {callToAction.text}
          </InfoButton>
        )}
      </div>
    </div>
  )
}

export default FinalCTASection
